// extracted by mini-css-extract-plugin
export default {"container":"ButtonAction_Icon_container__SO2HK","label":"ButtonAction_Icon_label__6U1vd","icon":"ButtonAction_Icon_icon__u9R7F"};